<template>
    <div class="device-list">
        <el-table
            v-if="target === 'quick'"
            :data="deviceData"
            style="width: 100%;margin-bottom: 20px;"
            >
            <el-table-column
            prop="name"
            :label="$t('device_list.robot_name')"
            width="200">
            <template slot-scope="{row}">
                <div style="width: 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{row.clientName}}</div>
                <div style="margin-top:6px;" :class="{'is-online': row.isOnline}">
                    <span class="online-marker"></span>
                    <span class="sn-number">已連線</span>
                </div>
            </template>
            </el-table-column>
            <el-table-column
            prop="imageVer"
            :label="$t('device_list.soft_version')"
            width="160">
            <template slot-scope="{row}">
                <div :class="{warn: !row.isDeploy}">
                    <span>{{row.imageVer}}</span>
                    <el-tooltip v-if="!row.isDeploy"  popper-class="export-project-tooltip" placement="bottom-end">
                        <div class="toolti-content" slot="content">
                            {{$t('device_list.soft_version_conflict')}}
                        </div>
                        <span class="el-icon-warning-outline warn-trigger"></span>
                    </el-tooltip>
                </div>
            </template>
            </el-table-column>
            <el-table-column
            prop="freeMemory"
            :label="$t('device_list.free_memory')"
            width="120"
            >
                <template slot-scope="{row}">
                    <div :class="{warn: !row.hasMemeory}">
                        <span>{{row.freeMemory}}</span>
                        <el-tooltip v-if="!row.hasMemeory" popper-class="export-project-tooltip" placement="bottom-end">
                            <div class="toolti-content" slot="content">
                                {{$t('device_list.free_memory_inenough')}}
                            </div>
                            <span class="el-icon-warning-outline warn-trigger"></span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="warnMessage" width="120">
                <template slot-scope="{row}">
                    <div class="warn">
                        <p class="warn-message" v-for="message in row.warnMessage" :key="message">{{message}}</p>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <template v-if="target === 'rms' || target === 'white'">
            <div class="list-header">
                <div style="width: 276px;padding-left:56px" >{{$t('device_list.group_robot_name')}}</div>
                <div style="width: 188px;">{{$t('device_list.soft_version')}}</div>
                <div>{{$t('device_list.free_memory')}}</div>
            </div>
            <el-scrollbar ref="scrollBar" style="width: 100%;height:200px;overflow:hidden;">
                <el-tree
                ref="deviceTree"
                class="device-group-tree"
                :data="deviceData"
                show-checkbox
                node-key="clientId"
                :expand-on-click-node="false"
                :props="{ ...propsTree, disabled: isDisabled }"
                check-on-click-node
                @check-change="handleCheckChange"
                >
                <!-- children: 'devices', -->
                <div class="custom-tree-node" slot-scope="{ data }">
                    <template v-if="data.type==='group'">
                        <div class="name" style="width:212px;">{{data.name}}</div>
                        <div class="device-count">{{$t("export_project.group_device_count", {count: data.deviceCount})}}</div>
                    </template>
                    <template v-if="data.type === 'device'">
                        <div class="name" style="width:194px;">
                            <div style="width: 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{data.clientName}}</div>
                            <div style="margin-top:6px;" :class="{'is-online': data.isOnline}">
                                <span class="online-marker"></span>
                                <span class="sn-number">{{getOnlineInfo(data.connState).text}}</span>
                            </div>
                        </div>
                        <div class="image-version"  style="width:190px;" :class="{warn: !data.isDeploy}">
                            <span>{{data.imageVer}}</span>
                            <el-tooltip v-if="!data.isDeploy"  popper-class="export-project-tooltip" placement="bottom-end">
                                <div class="toolti-content" slot="content">
                                    {{$t('device_list.soft_version_conflict')}}
                                </div>
                                <span class="el-icon-warning-outline warn-trigger"></span>
                            </el-tooltip>
                        </div>
                        <div class="free-memory" :class="{warn: !data.hasMemeory}">
                            <span>{{data.freeMemory}}</span>
                            <el-tooltip v-if="!data.hasMemeory" popper-class="export-project-tooltip" placement="bottom-end">
                                <div class="toolti-content" slot="content">
                                    {{$t('device_list.free_memory_inenough')}}
                                </div>
                                <span class="el-icon-warning-outline warn-trigger"></span>
                            </el-tooltip>
                        </div>
                    </template>
                </div>
                </el-tree>
            </el-scrollbar>
        </template>
        
    </div>
</template>
<script>
export default {
    name: "device-list",
    props: {
        data: Array,
        target: String,
        totalSize: Number
    },
    data(){
        return {
            deviceData: []
        }
    },
    computed: {
        propsTree () {
            if (this.target === 'rms') {
                return { children: 'devices', }
            }
            return {}
        }
    },
    watch: {
        data(value){
            this.initData(value);
        },
        deviceData(){
            this.$nextTick(() => {
                if(this.$refs.scrollBar){
                    this.$refs.scrollBar.update();
                }
            })
        }
    },
    created(){
        console.log('data', this.data)
        this.initData(this.data);
    },
    methods: {
        getOnlineInfo (connState) {
            if (connState == 2) {
                return {
                    text: "已連線",
                };
            }
            if (connState == 1) {
                return {
                    text: "待連線",
                };
            }
            return {
                text: "離線",
            };
        },
        initData(data){
            let deviceData;
            if(!data || !(data instanceof Array)){
                deviceData = [];
            } else {
                if(this.target === "quick"){
                    deviceData = this.initDeviceData(data);
                    if(deviceData.length > 0){
                        this.$emit("select-device", [deviceData[0].clientId]);
                    }
                } else if(this.target === "rms"){
                    deviceData = data.map(group => {
                        return Object.assign(group, {type: "group", devices: this.initDeviceData(group.devices)})
                    })
                } else if (this.target === "white"){
                    deviceData = this.initDeviceData(data)
                }
            }
            this.deviceData = deviceData
        },
        initDeviceData(data){
            return data.map(device => {
                let hasMemeory = this.robotHasMemory(this.totalSize, device.freeMemory);
                let warnMessage = [];
                if(!hasMemeory){
                    warnMessage.push(this.$t("device_list.care_memory"))
                }
                if(!device.isDeploy){
                    warnMessage.push(this.$t("device_list.version_conflict_export"))
                }
                const isOnline = this.target === 'quick' ? true: device.isOnline;
                return Object.assign({}, device, {hasMemeory, warnMessage, isOnline, type: "device"})
            })
        },
        isDisabled(data){
            if(data.type === "group" && data.devices.some(device => device.connState == 0)){
                return true;
            }
            if(data.type === "device" && data.connState == 0){
                return true;
            }
            return false;
        },
        //m1是否大于m2
        robotHasMemory(prm, rom){
            prm = prm + "";
            rom = rom + "";
            var sizeStr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']; //容量单位
            var format1 = prm.match(new RegExp(`\(${sizeStr.join("|")}\)`, "i")) || ["", "B"];
            var format2 = rom.match(new RegExp(`[\ \\d]\(${sizeStr.join("|")}\)`, "i")) || ["", "B"];
            prm = parseFloat(prm);
            rom = parseFloat(rom);
            if(format1 && format2){
                format1 = sizeStr.findIndex(item => item === format1[1].toUpperCase());
                format2 = sizeStr.findIndex(item => item === format2[1].toUpperCase());
                return prm - rom * Math.pow(1024, format2 - format1) <= 0;
            }
            return true;
        },
        handleCheckChange() {
            const selectedDevices = this.$refs.deviceTree.getCheckedKeys().filter(item => !!item);
            this.$emit("select-device", selectedDevices);
        },
    }
}
</script>
<style lang="scss">
.device-list{
    .el-table thead{
        color: #ffffff;
    }
    .el-table, .el-table__expanded-cell{
        background-color: transparent;
        color: #ffffff;
    }
    .el-table th, .el-table tr,.el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: transparent;
    }
    .el-table--enable-row-transition .el-table__body td{
        .cell{
            span{
                vertical-align: middle;
            }
        }
    }
    .list-header{
        color: #ffffff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px solid rgba(235, 238, 245, 0.5);
        &>div{
            padding-left: 12px;
            height: 28px;
            line-height: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .el-tree.device-group-tree{
        width: 100%;
        overflow: hidden;
        &>.el-tree-node{
            border-bottom: 1px solid rgba(235, 238, 245, 0.5);
            &.is-expanded>.el-tree-node__content{
                border-bottom: 1px solid rgba(0, 224, 218, 0.05);
            }
            .el-tree-node:not(:last-child){
                border-bottom: 1px solid rgba(0, 224, 218, 0.05);
            }
        }
        .el-tree-node__content>label.el-checkbox{
            margin: 0 12px;
        }
        .el-checkbox {
            .el-checkbox__inner{
                background: transparent;
                border-color: #dcdfe6;
            }
            &.is-disabled{
                .el-checkbox__inner{
                    border-color: #696969;
                }
            }
        } 
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            background: #00b5e2;
            border-color: #00b5e2;
        }
        .el-checkbox__inner::after{
            border-color: #272727;
        }
        .el-tree-node__content{
            height: 60px;
            background-color: transparent;
            .el-tree-node__expand-icon{
                font-size: 16px;
                &.el-icon-caret-right:before{
                    content: "\e6e0";
                }
            }
        }
        .el-tree-node__content:hover {
            background-color: rgba(0, 224, 218, 0.05);
        }
        .custom-tree-node{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 13px;
            &>div{
                padding: 0 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .online-marker{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 8px;
        border: solid 1px #333333;
        background-color: rgba(105, 105, 105, 0.3);
    }
    .sn-number{
        color: #a8a8ac;
        font-size: 12px;
        margin-left: 6px;
    }
    .is-online{
        .online-marker{
            border: solid 1px #00e0da;
            background-color: rgba(0, 224, 218, 0.3);
        }
        .sn-number{
            color: #00e0da;
        }
    }
    .warn{
        color: #fd5c53;
        &>span{
            vertical-align: middle;
        }
    }
    .warn-trigger{
        display: inline-block;
        font-size: 18px;
        margin-left: 8px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        text-align: center;
        &:hover{
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
    .warn-message{
        font-size: 12px;
        line-height: 1.2em;
        margin: 6px 0;
    }
}
</style>